/* Stylesheet */

$max-height: 192px;

@keyframes slideDown {
  0% {
    opacity: 0;
    max-height: 0;
    transform: translateY(-21px);
  }
  100% {
    opacity: 1;
    max-height: $max-height;
    transform: translateY(0);
  }
}

.items_container {
  position: absolute;
  min-height: 121px;
  max-height: $max-height;
  width: 100%;
  border-radius: 0px 0px 8px 8px;
  overflow: auto;
  background: var(--ion-gradient-light);
  box-shadow: var(--ion-box-shadow);
  animation: slideDown 0.2s ease-out;
  z-index: 100;

  .item {
    --padding-start: 21px;
    --min-height: 48px;
    color: var(--ion-color-text-primary);
    --color-hover: var(--ion-color-text-tertiary);
    --background-hover-opacity: 0.0275;
    --ripple-color: transparent;
    --background: transparent;

    .name {
      color: var(--ion-color-text-primary);
    }

    .label {
      line-height: 2;
    }
  }
}
